import type { ReactNode } from 'react';
import { BrandLogo } from '@/components/brand/BrandLogo';
import { ThemeMenu } from '@/components/theme/theme';

/**
 * Moldura das telas sem sessão (login, esqueci a senha, nova senha): painel da marca no desktop e
 * o conteúdo centralizado, com logotipo e tema no topo.
 */
export function AuthScreen({ children }: { children: ReactNode }) {
  return (
    <div className="grid min-h-dvh bg-background lg:grid-cols-[minmax(0,5fr)_minmax(0,6fr)]">
      <aside className="relative hidden flex-col justify-between overflow-hidden bg-brand-panel p-12 text-brand-panel-foreground lg:flex">
        <BrandLogo inverse />
        <div className="relative max-w-md motion-safe:animate-[rise-in_600ms_var(--ease-out)_both]">
          <p className="text-4xl leading-tight font-extrabold tracking-tight text-balance xl:text-5xl">
            Estratégia que vira resultado.
          </p>
          <p className="mt-5 max-w-[42ch] text-base text-brand-panel-foreground text-pretty">
            Mapa estratégico, indicadores, metas e planos de ação da sua empresa no mesmo lugar, com o
            acompanhamento da Fluxus.
          </p>
        </div>
        <TrafficLight />
      </aside>

      <main className="flex flex-col px-4 py-6 sm:px-8">
        <div className="flex items-center justify-between lg:justify-end">
          <BrandLogo className="lg:hidden" />
          <ThemeMenu />
        </div>
        <div className="flex flex-1 items-center justify-center py-10">
          <div className="w-full max-w-sm motion-safe:animate-[rise-in_400ms_var(--ease-out)_both]">
            {children}
          </div>
        </div>
      </main>
    </div>
  );
}

/** Os cinco estados do semáforo de performance (PRD §15), como assinatura visual do painel. */
function TrafficLight() {
  const colors = [
    'bg-status-green-solid',
    'bg-status-blue-solid',
    'bg-status-yellow-solid',
    'bg-status-red-solid',
    'bg-status-gray-solid',
  ];
  return (
    <div aria-hidden className="flex items-center gap-2">
      {colors.map((c, i) => (
        <span
          key={c}
          className={`h-2 rounded-full ring-2 ring-brand-panel-foreground/25 ${c} motion-safe:animate-[fade-in_500ms_var(--ease-out)_both]`}
          style={{ width: i === 0 ? '3rem' : '1.25rem', animationDelay: `${300 + i * 80}ms` }}
        />
      ))}
    </div>
  );
}
